import { ArrowUpRight, MapPin } from "lucide-react";
import { motion } from "framer-motion";

const COVER = "https://images.unsplash.com/photo-1628682814595-a3f0816b25ff?auto=format&fit=crop&w=1200&q=80";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-7 flex flex-col gap-8">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold text-[#2E1A6B]"
            >
              <span className="inline-block h-2 w-2 bg-[#2AC1E0]" />
              Issue 01 · Q1 2026 · Cover Story
              <MapPin size={14} className="ml-2" />
              Accra, Ghana
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.05 }}
              data-testid="hero-headline"
              className="font-display font-black tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] text-[#1A1A1A]"
            >
              The generation
              <br />
              that refuses to
              <br />
              <span className="italic text-[#2E1A6B]">whisper.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="text-base md:text-lg leading-relaxed text-[#4A4A4A] max-w-xl"
            >
              Listen is Ghana&apos;s magazine for adolescents and young adults — a stage for real
              stories, practical knowledge, and role models building the next Africa. Print, free.
              Digital, in your pocket.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="flex flex-wrap items-center gap-3 pt-2"
            >
              <a
                href="#subscribe"
                data-testid="hero-subscribe-btn"
                className="inline-flex items-center gap-2 px-6 py-4 bg-[#2E1A6B] text-white text-sm uppercase tracking-[0.2em] font-semibold hover:bg-[#2AC1E0] hover:text-[#2E1A6B] transition-colors"
              >
                Read the Issue
                <ArrowUpRight size={18} />
              </a>
              <a
                href="#partners"
                data-testid="hero-advertise-btn"
                className="inline-flex items-center gap-2 px-6 py-4 border border-[#2E1A6B] text-[#2E1A6B] text-sm uppercase tracking-[0.2em] font-semibold hover:bg-[#2E1A6B] hover:text-white transition-colors"
              >
                Partner With Us
              </a>
            </motion.div>

            <div className="grid grid-cols-3 gap-6 pt-8 max-w-md border-t border-[#2E1A6B]/15 pt-6">
              {[
                { k: "13–25", v: "Readers" },
                { k: "50+", v: "Distribution points" },
                { k: "Q", v: "Quarterly print" },
              ].map((s) => (
                <div key={s.v} data-testid={`hero-stat-${s.v.toLowerCase().split(" ")[0]}`}>
                  <div className="font-display text-3xl md:text-4xl leading-none text-[#2E1A6B]">{s.k}</div>
                  <div className="mt-2 text-[11px] uppercase tracking-[0.2em] text-[#4A4A4A]">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          <motion.div
            id="cover"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="lg:col-span-5 relative"
          >
            <div className="relative overflow-hidden border border-[#2E1A6B]/20">
              <img
                src={COVER}
                alt="Cover story portrait"
                className="w-full h-[70vh] max-h-[720px] object-cover"
              />
              <div className="absolute top-4 left-4 bg-[#F4F4F0] px-3 py-1.5 text-[11px] uppercase tracking-[0.2em] font-semibold text-[#2E1A6B]">
                Cover · Ama Serwaa
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/85 via-black/40 to-transparent">
                <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2AC1E0] mb-2">
                  Feature · 8 min read
                </div>
                <div className="font-display text-white text-2xl md:text-3xl leading-tight tracking-tight">
                  &ldquo;I built my first business at 19. Nobody handed it to me.&rdquo;
                </div>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between text-xs uppercase tracking-[0.2em] text-[#4A4A4A]">
              <span>Photography · K. Mensah</span>
              <span>Vol. 01 / 004</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
